import { useCursorHandlers } from '../../../contexts/CursorContext/Cursor';
import { useTheme } from '@mui/material/styles';

export const useEditorHandlers = (name: string) => {
  const theme = useTheme();

  return useCursorHandlers({
    name,
    styles: [
      {
        type: 'divider',
      },
      {
        type: 'header',
        label: 'Arrows',
      },
      {
        name: 'theme_component_list_arrow_background_color',
        label: 'Arrow background color',
        type: 'color',
        default: theme.palette.secondary.main,
      },
      {
        name: 'theme_component_list_arrow_hover_background_color',
        label: 'Arrow Hover background color',
        type: 'color',
        default: theme.palette.secondary.main,
      },
      {
        name: 'theme_component_list_arrow_svg_color',
        label: 'Arrow icon color',
        type: 'color',
        default: theme.palette.common.white,
      },
      {
        name: 'theme_component_list_arrow_width',
        label: 'Arrow width',
        type: 'number',
        endAdornment: 'px',
        default: 40,
      },
      {
        name: 'theme_component_list_arrow_min_width',
        label: 'Arrow minimum width',
        type: 'number',
        endAdornment: 'px',
        default: 40,
      },
      {
        name: 'theme_component_list_arrow_height',
        label: 'Arrow height',
        type: 'number',
        endAdornment: 'px',
        default: 40,
      },
      {
        name: 'theme_component_list_arrow_minimum_height',
        label: 'Arrow height',
        type: 'number',
        endAdornment: 'px',
        default: 40,
      },
      {
        type: 'divider',
      },
      {
        type: 'header',
        label: 'Left arrow',
      },
      {
        name: 'theme_component_list_arrow_left_left',
        label: 'Left margin',
        type: 'number',
        endAdornment: 'px',
        default: 0,
      },
      {
        name: 'theme_component_list_arrow_left_border_radius',
        label: 'Border radius',
        type: 'text',
        default: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`,
        helperText: 'Define as top right left bottom; e.g.: 2px 10px 5px 10px',
      },
      {
        name: 'theme_component_list_arrow_left_svg_margin_left',
        label: 'Icon left margin',
        type: 'number',
        endAdornment: 'px',
        default: theme.spacing(1),
      },
      {
        name: 'theme_component_list_arrow_left_svg_font_size',
        label: 'Icon size',
        type: 'number',
        endAdornment: 'px',
        default: theme.typography.body1.fontSize,
      },
      {
        type: 'divider',
      },
      {
        type: 'header',
        label: 'Right arrow',
      },
      {
        name: 'theme_component_list_arrow_right_right',
        label: 'Right margin',
        type: 'number',
        endAdornment: 'px',
        default: 0,
      },
      {
        name: 'theme_component_list_arrow_right_border_radius',
        label: 'Border radius',
        type: 'text',
        default: `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`,
        helperText: 'Define as top right left bottom; e.g.: 2px 10px 5px 10px',
      },
      {
        name: 'theme_component_list_arrow_right_svg_margin_right',
        label: 'Icon right margin',
        type: 'number',
        endAdornment: 'px',
        default: theme.spacing(1),
      },
      {
        name: 'theme_component_list_arrow_right_svg_font_size',
        label: 'Icon size',
        type: 'number',
        endAdornment: 'px',
        default: theme.typography.body1.fontSize,
      },
    ],
    configuration: [],
  });
}